import { useEffect, useState } from 'react'
import { Card, CardContent, CardHeader } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { ShieldWarning } from '@phosphor-icons/react'

const REDIRECT_DELAY_S = 3
const TENANT_URL = import.meta.env.VITE_TENANT_URL || '/'

export function AccessDenied() {
  const [countdown, setCountdown] = useState(REDIRECT_DELAY_S)

  useEffect(() => {
    // Clear the flag set by login page
    sessionStorage.removeItem('admin-not-authorized')

    const interval = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(interval)
          window.location.href = TENANT_URL
          return 0
        }
        return prev - 1
      })
    }, 1000)

    return () => clearInterval(interval)
  }, [])

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <div className="w-full max-w-sm">
        <Card className="relative overflow-hidden border-border/50">
          {/* Red gradient line at top to indicate restricted */}
          <div className="absolute inset-x-0 top-0 h-0.5 bg-gradient-to-r from-transparent via-destructive to-transparent" />

          <CardHeader className="space-y-3 pb-2 pt-8 text-center">
            <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-destructive/10">
              <ShieldWarning className="h-6 w-6 text-destructive" weight="duotone" />
            </div>
            <h1 className="text-lg font-semibold tracking-tight text-foreground">
              Access Restricted
            </h1>
          </CardHeader>

          <CardContent className="space-y-6 pb-8 pt-2 text-center">
            <p className="text-sm text-muted-foreground">
              This area is reserved for platform administrators. You will be
              redirected to the application.
            </p>

            {/* Countdown progress */}
            <div className="space-y-2">
              <div className="mx-auto h-1.5 w-32 overflow-hidden rounded-full bg-muted">
                <div
                  className="h-full rounded-full bg-primary transition-all duration-1000 ease-linear"
                  style={{
                    width: `${((REDIRECT_DELAY_S - countdown) / REDIRECT_DELAY_S) * 100}%`,
                  }}
                />
              </div>
              <p className="text-xs text-muted-foreground">
                Redirecting in {countdown}s
              </p>
            </div>

            <Button
              variant="outline"
              size="sm"
              className="text-xs"
              onClick={() => {
                window.location.href = TENANT_URL
              }}
            >
              Go to application now
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}
